import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'
import './registerServiceWorker'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import vuetify from './plugins/vuetify';
import AOS from 'aos'
import VueTheMask from 'vue-the-mask'
import * as VueGoogleMaps from 'vue2-google-maps';
import VueApexCharts from 'vue-apexcharts'
import 'aos/dist/aos.css'
import 'vue2-animate/dist/vue2-animate.min.css'
/* eslint-disable */


Vue.component('apexchart', VueApexCharts)
Vue.config.productionTip = false;
Vue.use(VueTheMask)
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCLU5CpP0INkUL33qSvXQdvBTp1czTjlyQ",
    libraries: "places"
  }
});

firebase.auth().onAuthStateChanged(user => {
  new Vue({
    router,
    store,
    created () {
      AOS.init()
    },
    vuetify,
    render: h => h(App)
  }).$mount('#app')
});
